import React from 'react'

export default function FormTypeIcon() {
  return (
    <svg width="35px" height="35px" viewBox="0 0 46 46" xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="6" width="36" height="12" rx="3" stroke="currentColor" strokeWidth="2" fill="none"/>
      <rect x="5" y="22" width="17" height="18" rx="3" stroke="currentColor" strokeWidth="2" fill="none"/>
      <rect x="26" y="22" width="15" height="18" rx="3" stroke="currentColor" strokeWidth="2" fill="none"/>
    </svg>
  )
}
